import React from "react";
import ProjectIcon from "../../../../../../core/gd-ui/project-icon/project-icon-ui5";
// @ts-ignore
import Api from "core/gd/api/api";

import _ from "lodash";
import ProjectSession from "../../../../../model2/project/project-session";

type Props = {
    onCloseModal: callback
}
export default class ModalStarredBlock extends React.Component<Props> {
    onClickProject = (id: ID, e: React.SyntheticEvent) => {
        e.stopPropagation();
        this.props.onCloseModal();
        gd.goTo('p/'+id);
    }

    onUnStarProject = (projectId: ID, e: React.SyntheticEvent) => {
        e.stopPropagation();

        const item = gd.session.starredItems.getProjectStarredItem(projectId)
        if (!item) return

        gd.session.starredItems.removeItem(item)
        Api.Starred.removeFromStarred(null,projectId)

        this.forceUpdate()
    }
    render() {
        const starredProjects = _.chain(gd.session.starredItems.getProjectsIds())
            .map((projectId: ID)=>gd.session.projects.get(projectId)!)
            .filter((project)=>project.companyId === gd.companyId)
            .value();

        return (
            <div className="starred-block">
                <div className="ui5-header s11 no-accent on-gray">
                    <div className="left">
                        <div className="name">Starred</div>
                    </div>
                </div>

                {starredProjects.length === 0 &&
                <div className="ui5-txt-no-accent-small m-t-20">No items found</div>}

                {starredProjects.length > 0 &&
                <div className="ui5-summary-list no-line hover-right">
                    {_.map(starredProjects, (project:ProjectSession)=>
                        <div key={project.id} className="item" onClick={this.onClickProject.bind(this,project.id)}>
                            <div className="left">
                                <ProjectIcon project={project} colorize={true}/>
                                <div className="name-txt ui5-txt-default">{project.name}</div>
                            </div>
                            <div className="right">
                                <div className="delete ui5-ico-delete s14 gray v-a-middle" onClick={this.onUnStarProject.bind(this,project.id)}/>
                            </div>
                        </div>
                    )}
                </div>}
            </div>
        )
    }
}